import { render, staticRenderFns } from "./MainCpEdu.vue?vue&type=template&id=b138a748&scoped=true&"
import script from "./MainCpEdu.vue?vue&type=script&lang=js&"
export * from "./MainCpEdu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b138a748",
  null
  
)

export default component.exports